import request from "@/utils/interceptor.js";
// 咨询师服务项目列表
export function getConsultantServiceItem(params) {
  return request({
    url: `/api/pas/consultant-service-item`,
    method: "get",
    params
  });
}
// 新增咨询师服务项目
export function postConsultantServiceItem(data) {
  return request({
    url: `/api/pas/consultant-service-item`,
    method: "post",
    data
  });
}
// 更新咨询师服务项目
export function putConsultantServiceItem(data) {
  return request({
    url: `/api/pas/consultant-service-item/${data.id}`,
    method: "put",
    data
  });
}
// 删除咨询师服务项目
export function deleteConsultantServiceItem(id) {
  return request({
    url: `/api/pas/consultant-service-item/${id}`,
    method: "delete",
  });
}
// 咨询师资质认证列表
export function getConsultantQualification(params) {
  return request({
    url: `/api/pas/consultant-qualification`,
    method: "get",
    params
  });
}
// 新增咨询师资质认证
export function postConsultantQualification(data) {
  return request({
    url: `/api/pas/consultant-qualification`,
    method: "post",
    data
  });
}
// 更新咨询师资质认证
export function putConsultantQualification(data) {
  return request({
    url: `/api/pas/consultant-qualification/${data.id}`,
    method: "put",
    data
  });
}
// 删除咨询师资质认证
export function deleteConsultantQualification(id) {
  return request({
    url: `/api/pas/consultant-qualification/${id}`,
    method: "delete",
  });
}
// 批量保存咨询师排班
export function postSaveRules(data) {
  return request({
    url: `/api/pas/consultant-schedule/save-rules`,
    method: "post",
    data
  });
}
// 分页查询咨询师排班规则
export function getConsultantSchedule(params) {
  return request({
    url: `/api/pas/consultant-schedule`,
    method: "get",
    params
  });
}
//删除咨询师排班规则
export function deleteConsultantSchedule(id) {
  return request({
    url: `/api/pas/consultant-schedule/${id}`,
    method: "delete",
  });
}
//更新咨询师排班规则
export function putConsultantSchedule(data) {
  return request({
    url: `/api/pas/consultant-schedule/${data.id}`,
    method: "put",
    data
  });
}